import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WaitComponent } from './components/dialog/wait/wait.component';
import { A4PageTextEditorComponent } from './components/embedded/a4-page-text-editor/a4-page-text-editor.component';
import { QuillModule } from 'ngx-quill';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserPreviewComponent2 } from './components/preview/user-preview2/user-preview2.component';
import { PersistenceStateArrayComponent } from './components/embedded/persistence-state-array/persistence-state-array.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ChangeCollisionDialogComponent } from './components/dialog/change-collision-dialog/change-collision-dialog.component';
import { HiddenInputDirective } from './directives/hidden-input.directive';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { CompleteRequestDialogComponent } from './components/dialog/complete-request-dialog/complete-request-dialog.component';
import { MatInputModule } from '@angular/material/input';
import { ExternalChangePreviewComponent } from './components/preview/external-change-preview/external-change-preview.component';
import { DoubleCheckDialogComponent } from './components/dialog/double-check-dialog/double-check-dialog.component';
import { AuditActionPipe } from './pipes/audit-action.pipe';
import { UserPipe } from './pipes/user.pipe';
import { HtmlNoteDiffComponent } from './components/embedded/html-note-diff/html-note-diff.component';
import { SortedFormArrayPipe } from './pipes/sorted-form-array.pipe';
import { QuillNoteTypePipe } from './pipes/quill-note-type.pipe';
import { ExpandableDomElementDirective } from './directives/expandable-dom-element.directive';
import { ConcurrencyLabelComponent } from './components/embedded/concurrency-label/concurrency-label.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InputDialogComponent } from './components/dialog/input-dialog/input-dialog.component';
import { UploadInputDirective } from './directives/upload-input.directive';
import { HereMapDialogComponent } from './components/dialog/here-map-dialog/here-map-dialog.component';
import { DoubletCheckerComponent } from './components/embedded/doublet-checker/doublet-checker.component';
import { SortedObjectArrayPipe } from './pipes/sorted-object-array.pipe';
import { IssueTableComponent } from './components/embedded/issue-table/issue-table.component';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { IssueTypeNamePipe } from './pipes/issue-type-name.pipe';
import { OfferTableComponent } from './components/embedded/offer-table/offer-table.component';
import { QuillNoteTypeMismatchDialogComponent } from './components/dialog/quill-note-type-mismatch-dialog/quill-note-type-mismatch-dialog.component';
import { SecondsLeftPipe } from './pipes/seconds-left.pipe';
import { SelectCustomerComponent } from './components/select/select-customer/select-customer.component';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SelectProductFormComponent } from './components/select/select-product-form/select-product-form.component';
import { BeforeYetPipe } from './pipes/before-yet.pipe';
import { IssueStatusPipe } from './pipes/issue-status.pipe';
import { IssueStatusColorPipe } from './pipes/issue-status-color.pipe';
import { AutofocusDirective } from './directives/autofocus.directive';
import { ImageUploadDialogComponent } from './components/dialog/image-upload-dialog/image-upload-dialog.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { UserImagePipe } from './pipes/user-image.pipe';
import { PdfComponent } from './components/embedded/pdf/pdf.component';
import { ConfirmDialogComponent } from './components/dialog/confirm-dialog/confirm-dialog.component';
import { OfferStatusPipe } from './pipes/offer-status.pipe';
import { UserInitialsPipe } from './pipes/user-initials.pipe';
import { SelectIssueComponent } from './components/select/select-issue/select-issue.component';
import { AuditSpecialActionPipe } from './pipes/audit-special-action.pipe';
import { SecondsToPrettyFormatPipe } from './pipes/seconds-to-pretty-format.pipe';
import { MonthPipe } from './pipes/month.pipe';
import { TimeDiffPipe } from './pipes/time-diff.pipe';
import { PicturePipe } from './pipes/picture.pipe';

@NgModule({
  declarations: [
    AutofocusDirective,
    A4PageTextEditorComponent,
    WaitComponent,
    UserPreviewComponent2,
    PersistenceStateArrayComponent,
    ChangeCollisionDialogComponent,
    HiddenInputDirective,
    SidenavComponent,
    CompleteRequestDialogComponent,
    ExternalChangePreviewComponent,
    DoubleCheckDialogComponent,
    AuditActionPipe,
    UserPipe,
    HtmlNoteDiffComponent,
    SortedFormArrayPipe,
    QuillNoteTypePipe,
    ExpandableDomElementDirective,
    ConcurrencyLabelComponent,
    InputDialogComponent,
    UploadInputDirective,
    HereMapDialogComponent,
    DoubletCheckerComponent,
    SortedObjectArrayPipe,
    IssueTableComponent,
    IssueTypeNamePipe,
    OfferTableComponent,
    QuillNoteTypeMismatchDialogComponent,
    SecondsLeftPipe,
    SelectCustomerComponent,
    SelectProductFormComponent,
    BeforeYetPipe,
    IssueStatusPipe,
    IssueStatusColorPipe,
    ImageUploadDialogComponent,
    UserImagePipe,
    PdfComponent,
    ConfirmDialogComponent,
    OfferStatusPipe,
    UserInitialsPipe,
    SelectIssueComponent,
    AuditSpecialActionPipe,
    SecondsToPrettyFormatPipe,
    MonthPipe,
    TimeDiffPipe,
    PicturePipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    ReactiveFormsModule,
    MatSortModule,
    MatTableModule,
    MatProgressSpinnerModule,
    ImageCropperModule,
    QuillModule.forRoot()
  ],
  exports: [
    AutofocusDirective,
    A4PageTextEditorComponent,
    WaitComponent,
    UserPreviewComponent2,
    PersistenceStateArrayComponent,
    ChangeCollisionDialogComponent,
    SidenavComponent,
    HiddenInputDirective,
    AuditActionPipe,
    UserPipe,
    UserInitialsPipe,
    HtmlNoteDiffComponent,
    SortedFormArrayPipe,
    QuillNoteTypePipe,
    ExpandableDomElementDirective,
    ConcurrencyLabelComponent,
    UploadInputDirective,
    DoubletCheckerComponent,
    SortedObjectArrayPipe,
    IssueTableComponent,
    IssueTypeNamePipe,
    OfferTableComponent,
    SecondsLeftPipe,
    SelectCustomerComponent,
    SelectIssueComponent,
    SelectProductFormComponent,
    BeforeYetPipe,
    IssueStatusPipe,
    TimeDiffPipe,
    UserImagePipe,
    MonthPipe,
    PdfComponent,
    SecondsToPrettyFormatPipe,
    OfferStatusPipe,
    AuditSpecialActionPipe,
    PicturePipe
  ]
})
export class SharedModule { }
